import { SelectDesignTokens } from '@primeuix/themes/types/select';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const selectDropdownOverride: SelectDesignTokens = {
  root: {
    borderRadius: getRem(10),
    color: getColor('UiBlack'),
    focusBorderColor: getColor('SkyBlue55'),
    hoverBorderColor: getColor('Cyan'),
    disabledBackground: getColor('Sandstone95'),
    disabledColor: getColor('Sandstone40'),
  },

  list: {
    padding: '0',
    gap: '0',
  },

  option: {
    padding: `${getRem(6)} ${getRem(12)}`,
    borderRadius: '0',
    color: getColor('DarkBlue'),
    focusBackground: getColor('Sandstone95'),
    focusColor: getColor('DarkBlue'),
    selectedBackground: getColor('SkyBlue95'),
    selectedFocusBackground: getColor('SkyBlue95'),
    selectedColor: getColor('SeaBlue'),
    selectedFocusColor: getColor('SeaBlue'),
  },

  dropdown: {
    color: getColor('DarkBlue'),
  },
};
